export const getPageTypeFromPath = (path: string) => {
  if (path) {
    if (path.match(/\/objekt\/.+$/g)) {
      return 'product page';
    } else if (path.match(/\/(aterforsaljare|forhandler)\/.+$/g)) {
      return 'dealer page';
    }
  }
  return null;
};

class EventContext {
  private _pageType: string | null;

  constructor() {
    this._pageType = !process.env.SSR ? getPageTypeFromPath(document.location.href) : null;
  }

  get pageType() {
    return this._pageType;
  }

  set pageType(pageType) {
    this._pageType = pageType;
  }
}

export default new EventContext();
